import { PropsWithChildren } from 'react';

import ActionButton from './shared/ActionButton';
import Popup from './shared/Popup';

type PopupProps = PropsWithChildren<{
  open: boolean;
  setOpen: (value: boolean) => void;
  maintenance: boolean;
}>;

export default function NotAllowedPopup({ open, setOpen, maintenance }: PopupProps) {
  return (
    <Popup open={open} setOpen={setOpen} closeOnOutsideClick={false} closeButton={false} widthClass="w-full md:max-w-[30rem]">
      <div className="flex flex-col items-center w-full px-4">
        {maintenance && (
          <>
            <p className="text-theme-text text-lg">The game is currently in maintenance mode 🛠</p>
            <p className="text-theme-text text-md mt-4">
              {`We're adding new features and fixing bugs. We'll be back soon! 🚀`}
            </p>
          </>
        )}
        {!maintenance && (
          <>
            <p className="text-theme-text text-lg">
              The devnet sneak-peek is currently only available to pre-approved users.
            </p>
            <p className="text-theme-text text-md mt-4">
              If you would like to access the game, you need to be a Giants NFT holder.
            </p>
          </>
        )}
        <div className="w-full mt-10">
          <ActionButton
            onClick={async () => {
              window.location.reload();
            }}
          >
            Ok
          </ActionButton>
        </div>
      </div>
    </Popup>
  );
}
